import React, { Component } from 'react';

import { Project } from './../../../classes/project.class';

import { ProjectDetailPageController } from './project-detail.controller';

import ProjectComponent from './../../../components/project/project.component';

import TaskComponent from './../../../components/task/task.component';

let controller;


class ProjectListPage extends Component {
    constructor(props) {
        super(props);
        const PROJECT_ID = parseInt(this.props.history.location.pathname.replace('/projects/', ''));

        controller = new ProjectDetailPageController({apiUrl: '/api', user: this.props.user, projectId: PROJECT_ID});
        this.state = {
            project: controller.getProject(),
            tasks: controller.getTasks()
        }
    }

    componentWillMount() {
        controller.on('updateProject', () => {
            console.log(controller.getProject());
            this.setState({project: controller.getProject()});
        });

        controller.on('updateTasks', () => {
            console.log(controller.getTasks());
            this.setState({tasks: controller.getTasks()});
        });
        
    }

    _createProjectTask() {
        controller.createProjectTask();
    }

    render() {
        let tasks = []; 
        let projectName = this.state.project !== null ? this.state.project.name : '';
        console.log(this.state.project);
        this.state.tasks.forEach(task => {
            tasks.push(<TaskComponent key={task.id} tags={this.props.tags} task={task} deleteTask={controller.deleteTask.bind(controller)} updateTask={controller.updateTask.bind(controller)} />); 
        });

        if(tasks.length <= 0) {
            tasks = <li>Keine Aufgaben gefunden</li>
        }

        return (
            
            <div>
                <h3>Project: {projectName}</h3>
                <ul className="home-tasks">
                    {tasks}
                </ul>

                <button className="app-btn  app-btn--create" onClick={this._createProjectTask.bind(this)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>
            </div>
        );
    }
}

export default ProjectListPage;


// WEBPACK FOOTER //
// src/pages/project/detail/project-detail.page.js